import { createAsyncThunk } from '@reduxjs/toolkit';
import firebase from 'firebase/app';
import { INVITE_ALL_USERS } from '../../constants/post';

const COLLECTION_NAME = 'users';

const getUserCollection = () => firebase.firestore().collection(COLLECTION_NAME);

export const getAuthUserInfo = createAsyncThunk(
    'getAuthUserInfo',
    async (uid, { rejectWithValue }) => {
        try {
            if (!uid) return null;

            let result;

            await getUserCollection()
                .doc(uid)
                .get()
                .then(doc => {
                    if (doc.exists) {
                        result = doc.data();
                    } else {
                        console.log('No such document!');
                    }
                })
                .catch(function (error) {
                    console.log('Error getting document:', error);
                });

            return {
                user: result,
            };
        } catch (e) {
            return rejectWithValue(e.message);
        }
    }
);
